import { http } from '../../config/axios'

export default function getConsultaJson(id: string): Promise<any> {
    return http.get('/api/consulta/json/' + id)
        .then((r) => r.data)
        .catch((error) => {
            console.error('Erro ao buscar JSON da consulta', error)
            throw error
        })
}

